// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2m3_Z","selects":"Documents_selects__2x2tK"};